<template>
    <div
        class="product-list-options"
    >
        <template
            v-for="(option, index) in optionsList"
            :key="`option-${option.attribute.uid}`"
        >
            <div
                v-if="option.showOnCollectionPages && optionsModel[option.attribute.uid]"
                class="product-list-options-item"
            >
                <div
                    v-if="!hideLabel"
                    class="font-size-7 font-weight-medium text-uppercase mb-1"
                >
                    {{ option.attribute.name }}
                </div>
                <ProductsListOption
                    v-model="optionsModel[option.attribute.uid]!"
                    :option="option"
                    @options-model="onChange($event)"
                ></ProductsListOption>
            </div>
        </template>
    </div>
</template>

<script lang="ts" setup>
    import type {
        ProductOptionsModel,
        ProductAttrsDisabledModel,
        ProductAttrsGroupOption
    } from '~/types';
    
    import ProductsListOption from '~/components/products/products-list/ProductsListOption/ProductsListOption.vue';

    const props = defineProps<{
        optionsModel: ProductOptionsModel;
        optionsDisabledModel?: ProductAttrsDisabledModel;
        optionsList: ProductAttrsGroupOption[];
        hideLabel?: boolean;
    }>();

    const emit = defineEmits<{
        'on-change': [value: ProductOptionsModel];
    }>();

    function onChange(
        [uidAtt, uidAttVal, optionIndex]: [string, string, number]
    ): void {
        const model = Object.assign(
            {},
            props.optionsModel,
            { [uidAtt]: uidAttVal }
        );
        emit('on-change', model);
    }
</script>

<style lang="scss">
.product-list-options {
    margin-bottom: 0.6rem;
    margin-left: 0.6rem;

    &-item {
        & + & {
            margin-top: 1rem;
        }
    }
}
</style>
